import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import AuthContext from '../../../authentication/AuthContext';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import UserContext from '../../../user/UserContext';
import { useAlert } from 'react-alert';
import { handlePresellError } from '../AlertUtils';

export default function SmallPresellHeader(props) {
    let cas = useContext(AuthContext);
    let { userDetails } = useContext(UserContext);

    const [disableSubmit, setDisableSubmit] = useState(props.disableSubmit);

    const alert = useAlert();

    useEffect(() => {
        if (userDetails && userDetails.currentFranchise && props.updateTotals && disableSubmit) {
            setDisableSubmit(false);
        }
    }, [props.updateTotals, disableSubmit, userDetails]);

    const calculateTimeLeft = () => {
        var today = moment();
        var endDate = moment(props.presellHeaderThumbnail.orderDeadline, 'YYYY-MM-DD');

        if (endDate.isBefore(today)) {
            return ' Ordering Closed';
        }

        var diffDays = endDate.diff(today, 'days');
        var diffHours = endDate.diff(today, 'hours') % 24;
        var diffMins = endDate.diff(today, 'minutes') % 60;

        return ' ' + diffDays + 'd ' + diffHours + 'h ' + diffMins + 'm remaining';
    };

    function PresellTimer() {
        const [time, setTime] = React.useState(calculateTimeLeft());
        React.useEffect(() => {
            window.setInterval(() => {
                setTime(calculateTimeLeft());
            }, 1000);
        });

        return time;
    }

    function submitPresellOrder() {
        axios
            .post(
                window.CONFIG['ws.activoc-presell-public.orders.submit'].replace('{orderId}', props.orderId),
                {},
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json',
                        'x-franchise-code': userDetails.currentFranchise.code
                    }
                }
            )
            .then(response => {
                alert.success(
                    'Presell order submitted successfully. Changes can still be made and resubmitted until the ordering deadline has passed.'
                );
                setDisableSubmit(true);
                props.updateOtherHeaderSubmit(true);
                props.quantitiesUpdated(true);
            })
            .catch(error => {
                handlePresellError(alert, error, 'Could not submit Presell Order.');
            });
    }

    return (
        <div className={'content header-wrapper flex'}>
            <div className={'presell-mini-header-name'}>
                <strong>{props.presellHeaderThumbnail.name}</strong>
                <p className={'clock'}>
                    <span data-testid={'short-presell-header-countdown'} className={'countdown'}>
                        <FontAwesomeIcon icon={faClock} />
                        <PresellTimer />
                    </span>
                </p>
            </div>
            <div className={'center-info flex'}>
                <div>
                    <strong>Total Cases:</strong>
                    <span>{props.presellHeaderThumbnail.totalCases}</span>
                </div>
                {props.presellHeaderThumbnail.savings > 0 && (
                    <div>
                        <strong>Total Savings:</strong>
                        <span>{formatTotalCost(props.presellHeaderThumbnail.savings)}</span>
                    </div>
                )}
                <div>
                    <strong>Total Cost:</strong>
                    <span>{formatTotalCost(props.presellHeaderThumbnail.orderTotal)}</span>
                </div>
                <div className={'orderTotal'}>
                    {!props.presellHeaderThumbnail.isAllocation && (
                        <Button
                            variant={'primary'}
                            disabled={
                                (!userDetails.telesales &&
                                    (!userDetails.currentFranchise || userDetails.currentFranchise.onHold)) ||
                                disableSubmit || props.disableSubmit
                            }
                            data-testid={'submit-short-presell-button'}
                            onClick={submitPresellOrder}
                        >
                            Submit
                            <FontAwesomeIcon icon={faChevronRight} />
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

function formatTotalCost(input) {
    return (
        <strong>
            £{Math.trunc(input)}
            <sup>{(Math.abs(input) % 1).toFixed(2).substring(1)}</sup>
        </strong>
    );
}
